export const departmentText = {
    warehouse: 'Склад',
    factory: 'Цех',
}

export const getDepartmentTypeFromDepartmentObj = ({ department }) => {
    try {
        let type = ''

        if (department && department.type) {
            type = department.type
        }

        return type
    } catch (e) {

    }
}

export const getDepartmentIdFromDepartmentObj = ({ department }) => {
    try {
        let departmentId = ''

        if (department && department.type) {
            if (department.type === 'warehouse') {
                departmentId = department.id
            } else if (department.type === 'factory' && department.factory) {
                departmentId = department.factory.id
            }
        }

        return departmentId
    } catch (e) {

    }
}